import type { CommonNode } from '@vedalib/editor'
import { isCommonNode } from '@vedalib/editor'
import lodash from 'lodash'
import React, { useMemo } from 'react'

import { nodeWithDeviceMode } from 'components/Editor/EditorContext/selectors/block'
import type { PreviewMode } from 'services/Store/Project/enums'

import type { IColumnProps, INodeComponentProps } from '../Node/types'
import EditorColumn from './EditorColumn'
import PreviewColumn from './PreviewColumn'

const BLOCK_COMPONENTS: Partial<Record<PreviewMode, React.FC<IColumnProps>>> = {
  editor: EditorColumn,
}

const ColumnContainer: React.FC<INodeComponentProps<CommonNode>> = (props) => {
  const { node, mode, level = 0 } = props
  const { style } = nodeWithDeviceMode(node, mode.deviceMode)
  const padding = style.padding && style.padding.map((v: number) => `${v || 0}px`).join(' ')
  const colStyles = useMemo(() => ({ ...lodash.omit(style, ['scale']), padding }), [style, padding])

  const Component = BLOCK_COMPONENTS[mode.previewMode] || PreviewColumn
  if (isCommonNode(node)) {
    return <Component {...props} level={level} node={node} style={colStyles} />
  }
  return null
}

export default React.memo(ColumnContainer)
